import store from '@/store';

export default {
  id: {
    dbKey: 'id',
    type: 'string',
    displayName: 'ID',
  },
  name: {
    dbKey: 'name',
    type: 'string',
    displayName: 'App name',
  },
  code: {
    dbKey: 'code',
    type: 'string',
    displayName: 'App code',
    validationRules: [
      value => (!!value || (value && false)) || 'Required.',
      value => (store.state.availableAppCodes.includes(value)) || 'Wrong input value. Check tooltip (?)',
    ],
  },
  mock: {
    id: '',
    name: '',
    code: '',
  },
};
